import React from 'react';

import {
	ADMIN_SECURITY_CONFIGURATION_ANALYTICS_SOURCE,
	LazySecurityConfigurationPage,
} from '@confluence/site-settings';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';

export const AdminSecurityConfigurationRoute = () => <LazySecurityConfigurationPage />;

AdminSecurityConfigurationRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: ADMIN_SECURITY_CONFIGURATION_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
